import { useAuth } from '../../../hooks/useAuth';

interface HeaderProps {
  onRefresh: () => void;
}

export default function Header({ onRefresh }: HeaderProps) {
  const { signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    // @ts-expect-error - REACT_APP_NAVIGATE is injected globally via router setup
    window.REACT_APP_NAVIGATE('/login');
  };

  const handleBackToDashboard = () => {
    // @ts-expect-error - REACT_APP_NAVIGATE is injected globally via router setup
    window.REACT_APP_NAVIGATE('/employee-dashboard');
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-40">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button
              onClick={handleBackToDashboard}
              className="text-gray-600 hover:text-gray-900 transition-colors"
              title="Back to Dashboard"
            >
              <i className="ri-arrow-left-line text-2xl"></i>
            </button>
            <h1 className="text-xl font-bold text-gray-900">Referrals</h1>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={onRefresh}
              className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
              title="Refresh"
            >
              <i className="ri-refresh-line text-xl"></i>
            </button>

            <button
              onClick={handleSignOut}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium"
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
